export const STATS = [
  { value: "1,079", label: "Official NATS airspace zones live on our map" },
  { value: "400ft", label: "Absolute legal height limit (120m) for all drones" },
  { value: "£11.79", label: "Operator ID annual cost — required for most drones" },
  { value: "5 years", label: "Flyer ID validity — the test is completely free" },
];

export const WEIGHT_RULES = [
  {
    id: "sub250",
    title: "Under 250g",
    badge: "A1 / C0 — e.g. DJI Mini series",
    color: "#2ec4b6",
    rules: [
      "Fly over people allowed — but NEVER over open-air crowds or assemblies",
      "No minimum separation distance from uninvolved people",
      "Fly in residential, commercial, industrial and recreational areas",
      "Flyer ID NOT required (unless you want it) — Operator ID IS required if it has a camera and isn't a toy",
      "Still 100% banned inside airport FRZs and restricted airspace",
      "Max height 400ft (120m) above ground level, always within visual line of sight",
    ],
  },
  {
    id: "a2",
    title: "250g – 900g",
    badge: "A2 / C1 — e.g. DJI Air series",
    color: "#3399ff",
    rules: [
      "Flyer ID AND Operator ID both legally required",
      "Never fly over uninvolved people — plan flight paths around them",
      "Keep 30m horizontal distance from uninvolved people",
      "5m separation allowed in low-speed mode with an A2 Certificate of Competence",
      "A2 CofC theory exam ≈ £100 via CAA-approved providers, valid 5 years",
      "No flying over crowds under any circumstances",
    ],
  },
  {
    id: "heavy",
    title: "Over 900g – 25kg",
    badge: "A2 CofC / A3 — e.g. Mavic 3, FPV rigs, cine lifts",
    color: "#ff7849",
    rules: [
      "Without A2 CofC: fly ONLY in A3 — 150m away from residential, commercial, industrial and recreational areas",
      "Keep at least 50m from uninvolved people at all times in A3",
      "2kg–25kg drones are A3-only in the Open category regardless of certificates",
      "Commercial work usually needs a GVC (General VLOS Certificate) + Operational Authorisation (~£1,500 all-in)",
      "Commercial flights require EC 785/2004 compliant insurance",
      "Over 25kg = Certified category — full aircraft-style regulation",
    ],
  },
];

export const ID_FACTS = [
  {
    title: "Flyer ID",
    cost: "FREE",
    items: [
      "40-question multiple choice test on the CAA website — pass mark 30",
      "Valid for 5 years, take it as many times as you like",
      "Required for anyone flying a drone 250g+ (or any drone in A2)",
      "No minimum age — children can hold a Flyer ID",
    ],
  },
  {
    title: "Operator ID",
    cost: "£11.79 / year",
    items: [
      "Required if your drone weighs 250g+ OR has a camera (toys exempt)",
      "Must be 18 or over to register as an operator",
      "The Operator ID must be visibly labelled on every drone you own",
      "One Operator ID covers all your drones — renew annually",
    ],
  },
  {
    title: "Penalties",
    cost: "Up to 5 years prison",
    items: [
      "Flying unregistered: fines up to £1,000",
      "Flying in restricted airspace / over crowds: fines from £2,500 upwards",
      "Endangering an aircraft: UNLIMITED fine and up to 5 years imprisonment",
      "Police have powers to seize drones and ground pilots on the spot",
    ],
  },
];

export const KEY_FACTS = [
  { title: "The 400ft ceiling", text: "120m above ground level is the absolute limit for every drone in the Open category — measured from the ground beneath the drone, so you can follow hillsides upward but never exceed 400ft above the surface." },
  { title: "Airport FRZs", text: "Every protected aerodrome has a Flight Restriction Zone: a 2–2.5 nautical mile cylinder plus 5km × 1km runway protection zones. Flying inside one without Air Traffic Control permission is a criminal offence — even with a 249g drone." },
  { title: "Visual Line of Sight", text: "You must always see your drone with your own eyes (glasses OK, binoculars not). Practical VLOS is roughly 500m horizontally — FPV flying requires a competent observer beside you." },
  { title: "Night flying", text: "Legal in the UK since 2021. The drone should have lit anti-collision lighting, and you must still maintain VLOS — position lights help you keep orientation." },
  { title: "TOAL — Take Off & Landing", text: "Airspace above land is generally free to fly through, but you need the landowner's permission to take off and land. Councils, the National Trust and Royal Parks commonly ban TOAL on their land — launch from public rights of way or permissive land instead." },
  { title: "Danger Areas & HIRTAs", text: "220+ MOD danger areas (live firing, fast jets) and High Intensity Radio Transmission Areas cover the UK. Many are 'active by NOTAM' — check activity before flight. Radio interference can sever your control link above 100ft near HIRTAs." },
  { title: "SSSIs & wildlife", text: "Disturbing protected wildlife with a drone can be an offence under the Wildlife and Countryside Act 1981 — up to £5,000 per offence. Ground-nesting bird season (March–August) is the highest-risk period on moorland and coastal sites." },
  { title: "Insurance", text: "Hobby flying under 20kg needs no insurance by law (though public liability cover such as FPV UK / BMFA membership is smart). ANY commercial flight requires EC 785/2004 compliant insurance — no exceptions." },
];

export const AI_CHIPS = [
  "Can I fly over a beach?",
  "Do I need a licence for a DJI Mini 4 Pro?",
  "What happens if I fly in an FRZ?",
  "Best drone under £500?",
  "Can I fly at night?",
  "How do I get my A2 CofC?",
];
